import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/error.tsx")